/* eslint-disable node/no-unsupported-features */
export const HOME_POSTS = '3';

export const ABOUT_IT = '28';
export const ABOUT_EN = '26';

export const PRIVACY_IT = '38';
export const PRIVACY_EN = '48';

export const TERMS_IT = '43';
export const TERMS_EN = '46';



// WEBPACK FOOTER //
// ./src/constants/CategoryTypes.js